import { logClientError } from '@utils/server-log';
import { IndividualConfig, ToastrService } from 'ngx-toastr';

let toastrService: ToastrService;

/**
 * Inicializa o serviço de toast para uso global
 * Deve ser chamado no AppComponent
 */
export function initGlobalToastr(service: ToastrService) {
  toastrService = service;
}

/**
 * Exibe um toast que pode ser chamado de qualquer lugar da aplicação,
 * sem necessidade de injetar o serviço
 */
export function showToast(
  message: string,
  title: string,
  type: 'success' | 'error' | 'info' | 'warning',
  options?: Partial<IndividualConfig>
) {
  if (!toastrService) {
    logClientError('ToastrService não foi inicializado. Chame initGlobalToastr no AppComponent.');
    return;
  }

  toastrService[type](message, title, {
    positionClass: 'toast-bottom-center',
    closeButton: true,
    timeOut: 1500,
    ...options,
  });
}

export function showSuccessToast(message: string, title: string = 'Sucesso!') {
  showToast(message, title, 'success');
}

export function showWarningToast(message: string, title: string = 'Atenção!') {
  showToast(message, title, 'warning');
}

export function showErrorToast(message: string, title: string = 'Atenção!') {
  showToast(message, title, 'error');
}

export function showInfoToast(message: string, title: string = 'Atenção!') {
  showToast(message, title, 'info');
}
